import { FC, useEffect } from 'react';
import { LearnosityReportRequest } from '../../../models/LearnosityRequest';
import { addLearnosityErrorBreadcrumb } from '../../../utils/learnositySentry';

interface Props {
  request: LearnosityReportRequest;
}

const ExitSlipFullDetailModalWrapper: FC<Props> = ({ request }) => {
  useEffect(() => {
    if (window.LearnosityReports) {
      window.LearnosityReports.init(request, {
        readyListener: () => {
          console.log('Learnosity Reports API is ready');
        },
        errorListener: error => {
          addLearnosityErrorBreadcrumb(error, {
            api: 'reports',
            operation: 'init',
            learnerIds: request.request.reports.flatMap(report => report.users.map(user => user.id)),
            sessionIds: request.request.reports.flatMap(report => report.session_ids),
          });
          console.error('Learnosity Reports API initialization error');
        },
      });
    }
  }, []);

  return (
    <div style={{ paddingTop: '4rem' }}>
      <div id="response-analysis-report"></div>
    </div>
  );
};

export default ExitSlipFullDetailModalWrapper;
